module.exports = __webpack_public_path__ + "static/img/Cody-Walker.79974a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cody-Walker.jpg
// module id = emRI
// module chunks = 0